module.exports = __webpack_public_path__ + "img/shield-fill.9154978a.svg";